import { PropsWithChildren } from 'react';

import { Flex } from '@revenuemarket/cds';
import { Colors, typographyStyle } from '@revenuemarket/design';
import { Typography } from 'antd';
import { css } from '~libs/emotion';

interface Props extends PropsWithChildren {}

const TableHeaderCell: React.FC<Props> = ({ children }) => {
  return (
    <Flex
      align="center"
      className={css`
        width: 160px;
        height: 30px;
        padding-left: 6px;
        box-shadow: 1px 0 0 0 ${Colors.grayOpacity07};
        &:hover {
          background-color: ${Colors.grayOpacity07};
        }
      `}
    >
      <Typography.Text
        style={{
          ...typographyStyle['13_400'],
        }}
      >
        {children}
      </Typography.Text>
    </Flex>
  );
};

export default TableHeaderCell;
